/** Competition settings, as far down as the Track Timeouts switch. */
interface SettingsWithScoring {
  settings?: {
    game?: {
      scoring?: { track_timeouts?: boolean | null } | null
    } | null
  } | null
}

/**
 * Whether a competition tracks timeouts: on, unless its settings switch it
 * off. A competition that never chose has no value stored, and that means on.
 */
export const readTrackTimeouts = (
  settings?: SettingsWithScoring | null
): boolean => settings?.settings?.game?.scoring?.track_timeouts !== false

/**
 * What a save of the scoring settings carries for Track Timeouts: the switch's
 * value once the admin has touched it, and nothing before that.
 *
 * A save that never touched the switch sends no key at all, so it cannot
 * overwrite a choice made elsewhere, and a competition that never chose stays
 * without a stored choice.
 */
export const trackTimeoutsToSave = (
  isOn: boolean,
  wasTouched: boolean
): { track_timeouts?: boolean } => (wasTouched ? { track_timeouts: isOn } : {})
